<template>
  <section class='why-help-find'>
    <b-container class='contents'>
      <b-row>
        <b-col>
          <div class='callout bg-gradient-103'>
            <div class='callout__contents'>
              <h2 class='text-center can-help-text'>
                JORNAY PM can help people find <br class='d-none d-md-block'>their shine from the time they rise.
              </h2>

              <p class='dark-text my-0 text-center'>
                In clinical studies, parents noticed improvements in their children’s ADHD symptoms upon waking in the
                morning, after school, and into the early evening.
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: 'WhyHelpFind'
}
</script>
